<template>
  <v-hover>
    <template v-slot:default="{ hover }">
      <v-card
        elevation="3"
        document
      >
        <v-img
          :src="previewImageUrl"
          aspect-ratio="1.8"
          class="grey lighten-2"
        />
        <v-card-title class="title">{{ title }}</v-card-title>

        <v-fade-transition>
          <v-overlay v-if="hover" absolute class="fileOverlay">
              <a :href="downloadUrl" target="_blank">
                <v-btn>Download</v-btn>
              </a>
          </v-overlay>
        </v-fade-transition>
      </v-card>
    </template>
  </v-hover>
</template>

<script>
import { STATIC_WEB_CONTENT_URL } from '@/constants'

const createDownloadLink = (title, ext) => res => {
  const blob = new Blob([res.data], { type: `application/${ext}` })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = title
  link.click()
  URL.revokeObjectURL(link.href)
}

export default {
  name: 'File',
  props: {
    title: String,
    slug: String,
    type: String
  },
  computed: {
    previewImageUrl () {
      const ext = 'jpeg'
      return `${STATIC_WEB_CONTENT_URL}/docs/${this.slug}.${ext}`
    },
    downloadUrl () {
      const ext = this.type === 'document' ? 'pdf' : 'jpeg'
      return `${STATIC_WEB_CONTENT_URL}/docs/${this.slug}.${ext}`
    }
  }
}
</script>
<style scoped>
  .fileOverlay {
    color: var(--v-tracefyBlue-base);
  }
</style>
